export default __webpack_public_path__ + "static/avatar-022ff680fad1bcb314759febc77acf39.png";